// Cookie-баннер: только веб-платформа, мини-аппы ТГ/Макс не трогаем — там согласие на
// аналитику покрыто политикой ПДн при оформлении заказа.
// Модель «продолжая пользоваться сайтом — согласие» (решение юзера 30.09.2026, раньше было
// «Принять / Отклонить»): Метрика на вебе стартует сразу (public/index.html), «ОК» только
// закрывает баннер. Кто раньше нажал «Отклонить» (CONSENT_NECESSARY), тому Метрику
// по-прежнему не включаем — баннер ему не показывается.
import { useState } from 'react';
import { getPlatform } from '../platform';
import { useLegalLinks } from '../legal';
import { getCookieConsent, saveCookieConsent, CONSENT_ALL } from '../utils/cookieConsent';

export default function CookieBanner() {
  const [consent, setConsent] = useState(getCookieConsent);
  const { policyUrl } = useLegalLinks();

  if (consent || getPlatform() !== 'web') return null;

  const handleOk = () => {
    saveCookieConsent(CONSENT_ALL);
    setConsent(CONSENT_ALL);
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 'calc(var(--nav-height) + var(--safe-area-bottom) + 10px)',
      left: 16,
      right: 16,
      maxWidth: 520,
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      gap: 14,
      background: 'var(--card-bg)',
      border: '1px solid var(--border-color)',
      borderRadius: 14,
      boxShadow: 'var(--shadow-hover)',
      padding: '12px 14px 12px 16px',
      zIndex: 1100,
    }}>
      <p style={{ margin: 0, flex: 1, fontSize: 13, lineHeight: 1.4, color: 'var(--text-secondary)' }}>
        Продолжая пользоваться сайтом, вы даёте{' '}
        <a
          href={policyUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'var(--text-color)', textDecoration: 'underline' }}
        >
          согласие
        </a>{' '}
        на использование файлов cookie.
      </p>
      <button
        onClick={handleOk}
        style={{
          flexShrink: 0,
          padding: '9px 18px',
          background: 'var(--primary-color)',
          color: 'var(--on-primary)',
          border: 'none',
          borderRadius: 10,
          fontFamily: 'inherit',
          fontSize: 14,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        ОК
      </button>
    </div>
  );
}
